import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { DeveloperLogsDownloadInput, DeveloperLogsDownloadPayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = DeveloperLogsDownloadInput;
type TData = DeveloperLogsDownloadPayload;

export const useDeveloperLogsDownload = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation developerLogsDownload($input: DeveloperLogsDownloadInput!) {
      developerLogsDownload(input: $input) {
        downloadId
        success
        errors
        errorCode
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
